export function getLocalStorageString(key: string): string | null {
    if (typeof window === "undefined") {
        return null;
    }
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
}

export function setStoredOption(key: string, optionId: string): void {
    if (typeof window === "undefined") {
        return;
    }
    try {
        localStorage.setItem(key, optionId);
    } catch {
    }
}

export function getStoredOption(
    key: string,
    allowed: readonly string[],
    fallbackId: string,
): string {
    const raw = getLocalStorageString(key);
    if (raw != null && allowed.includes(raw)) {
        return raw;
    }
    return fallbackId;
}
